import { useEffect, useState } from 'react';
import './scss/style.scss'
import "@coreui/coreui-pro/dist/js/coreui.bundle.min.js";
import "@coreui/coreui-pro/dist/css/coreui.min.css";
import "primereact/resources/themes/nova-accent/theme.css";
import "primereact/resources/primereact.min.css";
// Tema visual estilo Medusa: va después de CoreUI y PrimeReact para ganarles en cascada
import './scss/medusa.scss';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import SideBar from './layout/SideBar';
import Dashboard from './views/dashboard/Dashboard';
import Page404 from './views/pages/page404/Page404';
import { Login } from './views/pages/login/Login';
import { SignUp } from './views/pages/signup/SignUp';
import { DeliveryRouteAdministrator } from './views/controlpanel/DeliveryRouteAdministrator';
import { useIdleTimer } from 'react-idle-timer'
import { env } from './Utils/Environment';
import * as DomicilappService from "./services/DomicilappService";
import { getBaseToken, getToken, userLogout, saveBaseToken, saveToken, verifyRefreshToken } from './Utils/Auth';
import { getDeviceData, showToastTR } from './Utils/BaseApp';
import { getToken as getTokenFirebase, onMessage } from "firebase/messaging";
import { messaging } from './firebase/FirebaseConfig';
import { ToastContainer } from 'react-toastify';
import LoadingContainer from './components/loading/LoadingContainer';
import ConfirmContainer from './components/confirm/ConfirmContainer';
import ProductList from './views/products/list';
import ProductCreateWizard from './views/products/create';
import OrdersPage from './views/orders/OrdersPage';
import ProductCategories from './views/products/categories';
import ComboList from './views/combos/ComboList';
import ComboFormPage from './views/combos/ComboForm';
import MarketingCoupons from './views/marketing/coupons';
import MarketingReferrals from './views/marketing/referrals';
import Discounts from './views/marketing/Discounts';
import AdsList from './views/marketing/AdsList';
import AdForm from './views/marketing/AdForm';
import FinanceBalance from './views/finance/balance';
import SettingsPage from './views/settings/settings';
import StoreSchedulesPage from './views/store/schedules';
import StoreCreatePage from './views/store/create';
import StoreProfilePage from './views/store/profile';
import UserProfilePage from './views/user/profile';
import { StoreProvider } from './contexts/StoreContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { FleetProvider } from './contexts/FleetContext';
import FleetLivePage from './views/fleet/FleetLive';
import FleetDeliveriesPage from './views/fleet/FleetDeliveries';
import FleetCouriersPage from './views/fleet/FleetCouriers';

function App() {

  async function saveDevice() {
    getDeviceData().then((response) => {
      var device_id = response.device_id;
      var device_model = response.browser;
      var device_os = response.os;
      localStorage.setItem('device_id', device_id)
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          getTokenFirebase(messaging, {
            vapidKey: env('VAPID_KEY'),
          }).then(token => {
            DomicilappService.saveDevice({ token_notification_firebase: token, device_id: device_id, device_model: device_model, device_os: device_os, app_mobile_version: env('APP_VERSION') })
          });
        } else if (permission === "denied") {
          DomicilappService.saveDevice({ device_id: device_id, device_model: device_model, device_os: device_os, app_mobile_version: env('APP_VERSION') })
        } else {
          DomicilappService.saveDevice({ device_id: device_id, device_model: device_model, device_os: device_os, app_mobile_version: env('APP_VERSION') })
        }
      });
    })
  }

  useEffect(() => {
    saveDevice()
  }, []);

  onMessage(messaging, (payload) => {
    console.log(payload);
    var pathname = window.location.pathname;
    const isLoginPage = (pathname === "/login" || pathname === "/signup");

    console.log("Aqui se debe revisar que tipo de login es");
    if (!isLoginPage) {
      console.log("Aqui se debe enviar la notificación");
      showToastTR(payload?.notification?.title ?? "Algo", 3000, 'info')
    }
  });

  const [remaining, setRemaining] = useState<number>(0);

  const onIdle = () => {
    var pathname = window.location.pathname;
    const isLoginPage = (pathname === "/login" || pathname === "/signup");
    if (!isLoginPage) {
      userLogout();
    } else {
      console.log("No se debe cerrar por que estoy en el inicio de sesión")
    }
  };

  const onActive = () => {
    // console.log("Usuario activo");
  };

  const onAction = () => {
    var pathname = window.location.pathname;
    const isLoginPage = (pathname === "/login" || pathname === "/signup");

    if (!isLoginPage) {
      try {

        // Se deben actualizar los dos tokens
        const token = getToken();
        const baseToken = getBaseToken();
        if (token === baseToken) {
          if (verifyRefreshToken(token)) {
            DomicilappService.refreshToken().then((response) => {
              saveBaseToken(response.data.access_token)
              saveToken(response.data.access_token)
            });
          }
        } else {
          if (verifyRefreshToken(token)) {
            DomicilappService.refreshToken().then((response) => {
              saveToken(response.data.access_token)
            });
          }

          if (verifyRefreshToken(baseToken)) {
            DomicilappService.refreshBaseToken().then((response) => {
              saveBaseToken(response.data.access_token)
            });
          }
        }

      } catch (error) {
        console.log(error);
        userLogout()
      }

    }
  }

  const { getRemainingTime } = useIdleTimer({
    onIdle,
    onActive,
    onAction,
    timeout: parseInt(env('INACTIVITY_SESSION_TIME')) * 60 * 1000, // 5 minutos
    throttle: 500,
  });

  useEffect(() => {
    if (window.location.pathname !== '/login') {
      const interval = setInterval(() => {
        setRemaining(Math.ceil(getRemainingTime() / 1000));
      }, 500);

      return () => {
        clearInterval(interval);
      };
    }
  }, [getRemainingTime]);

  return (
    <NotificationProvider>

    <StoreProvider>
    <FleetProvider>


    <BrowserRouter>
      <LoadingContainer message={""} />
      <ConfirmContainer />
      <ToastContainer />
      <Routes>
        <Route path='/' element={<Navigate to="/login" />} />
        <Route path='/login' element={<Login />} />
        <Route path='/signup' element={<SignUp />} />
        <Route path='/dashboard' element={<SideBar><Dashboard /></SideBar>} />
        <Route path='/products/list' element={<SideBar><ProductList /></SideBar>} />
        <Route path='/products/create' element={<SideBar><ProductCreateWizard /></SideBar>} />
        <Route path='/products/edit/:id' element={<SideBar><ProductCreateWizard /></SideBar>} />
        <Route path='/products/categories' element={<SideBar><ProductCategories /></SideBar>} />
        <Route path='/combos/list' element={<SideBar><ComboList /></SideBar>} />
        <Route path='/combos/create' element={<SideBar><ComboFormPage /></SideBar>} />
        <Route path='/combos/edit/:id' element={<SideBar><ComboFormPage /></SideBar>} />
        <Route path='/marketing/coupons' element={<SideBar><MarketingCoupons /></SideBar>} />
        <Route path='/marketing/referrals' element={<SideBar><MarketingReferrals /></SideBar>} />
        <Route path='/marketing/discounts' element={<SideBar><Discounts /></SideBar>} />
        <Route path='/marketing/ads' element={<SideBar><AdsList /></SideBar>} />
        <Route path='/marketing/ads/create' element={<SideBar><AdForm /></SideBar>} />
        <Route path='/finance/balance' element={<SideBar><FinanceBalance /></SideBar>} />
        <Route path='/orders' element={<SideBar><OrdersPage view='all' /></SideBar>} />
        <Route path='/orders/active' element={<SideBar><OrdersPage view='active' /></SideBar>} />
        <Route path='/orders/pickup' element={<SideBar><OrdersPage view='pickup' /></SideBar>} />
        <Route path='/orders/history' element={<SideBar><OrdersPage view='history' /></SideBar>} />
        <Route path='/settings' element={<SideBar><SettingsPage /></SideBar>} />
        <Route path='/store/schedules' element={<SideBar><StoreSchedulesPage /></SideBar>} />
        <Route path='/store/create' element={<SideBar><StoreCreatePage /></SideBar>} />
        <Route path='/store/profile' element={<SideBar><StoreProfilePage /></SideBar>} />
        <Route path='/user/profile' element={<SideBar><UserProfilePage /></SideBar>} />
        {/* Mi flota (empresas de domicilios) */}
        <Route path='/fleet/live' element={<SideBar><FleetLivePage /></SideBar>} />
        <Route path='/fleet/deliveries' element={<SideBar><FleetDeliveriesPage /></SideBar>} />
        <Route path='/fleet/couriers' element={<SideBar><FleetCouriersPage /></SideBar>} />

        {/* SuperAdmin */}
        <Route path='/admin/cpanel/routes' element={<SideBar><DeliveryRouteAdministrator /></SideBar>} />
        <Route path='/admin/*' element={<SideBar><Page404 /></SideBar>} />
        <Route path='/*' element={<SideBar><Page404 /></SideBar>} />
        <Route path='*' element={<Page404 />} />
      </Routes>
      </BrowserRouter>
      </FleetProvider>
      </StoreProvider>
    </NotificationProvider>

  );
}

export default App;